import type { Action } from 'modules/global/generic.types';
import { createReducer } from 'utils/ReduxUtils';

import type { WrapperReducerConfig } from './reducers.types';
import { isSuccessRequest, isFailureRequest } from './utils';

type PartialPage = {
    number: number;
    size: number;
    totalPages?: number;
};

type SuccessPayload = {
    page?: PartialPage;
    content?: unknown[];
};

export const onSuccessRequest = (_: boolean, { payload }: Action<SuccessPayload>): boolean => {
  const { page, content } = payload ?? {};
  return (
    page != null &&
        (page.totalPages !== undefined
          ? page.number + 1 < page.totalPages
          : content?.length === page.size)
  );
};

const hasMore = (actionRoot: string, { reducers = {}, matchers = [], global: config }: WrapperReducerConfig<boolean> = {}) =>
  createReducer(false, reducers, [
    {
      matcher: isSuccessRequest(actionRoot, config ?? {}),
      reducer: onSuccessRequest,
    },
    {
      matcher: isFailureRequest(actionRoot, config ?? {}),
      reducer: () => false,
    },
    ...matchers,
  ]);

export default hasMore;
